<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed" :value="value">
          <vs-tab :label="$t('Sale')" @click="tabChanged(0)">
            <sale></sale>
          </vs-tab>
          <vs-tab :label="$t('Warehouse')" @click="tabChanged(1)">
            <warehouse></warehouse>
          </vs-tab>
          <vs-tab :label="$t('Financial')"  @click="tabChanged(2)">
            <financial></financial>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
  import Sale from './Sale.vue'
  import Warehouse from './Warehouse.vue'
  import Financial from './Financial.vue'
  
  export default {
    components: {
      Sale,
      Warehouse,
      Financial
    },
    data() {
      return {
        value: 0,
        notChanged: true,
        timeOutId:null
      }
    },
    mounted() {
      this.timeOutId = setTimeout(() => { this.value = 1;},30000)
    },
    watch: {
      'value'() {
        if (this.value == 0) {
          this.timeOutId = setTimeout(() => { this.value = 1; }, 30000);
          
        }
        if (this.value == 1) {
          this.timeOutId = setTimeout(() => { this.value = 2; }, 30000)
        }
        if (this.value == 2) {
          this.timeOutId = setTimeout(() => { this.value = 0; }, 30000)
        }
        //setInterval(function () {
        //  if (this.value < 2) {
        //    this.value = this.value + 1;
        //  }
        //}.bind(this), 3000);
      }
    },
    methods: {
      tabChanged(val) {
        clearTimeout(this.timeOutId);
        this.value = val;
      }
    }
  }
</script>
